"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _Checkbox = _interopRequireDefault(require("../../Checkbox"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
require("./LegendItem.css");
var styles = {
  "legend-item": "LegendItem__legend-item___1PLFt",
  "label": "LegendItem__label___25DOn",
  "check": "LegendItem__check___6D6lR",
  "legendItem": "LegendItem__legend-item___1PLFt"
};
var ChartLegend = exports["default"] = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(ChartLegend, _React$PureComponent);
  function ChartLegend(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, ChartLegend);
    _this = _callSuper(this, ChartLegend, [props]);
    _this.onClick = _this.onClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }
  (0, _createClass2["default"])(ChartLegend, [{
    key: "onClick",
    value: function onClick() {
      var _this$props = this.props,
        itemIndex = _this$props.itemIndex,
        onClick = _this$props.onClick;
      onClick(itemIndex);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        label = _this$props2.label,
        color = _this$props2.color,
        active = _this$props2.active;

      /* eslint-disable jsx-a11y/no-static-element-interactions */
      return /*#__PURE__*/_react["default"].createElement("div", {
        "data-legend-type": "legend-item",
        className: styles.legendItem
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        label: label,
        checked: active,
        color: color,
        onChange: this.onClick
      }));
    }
  }]);
  return ChartLegend;
}(_react["default"].PureComponent);
//# sourceMappingURL=LegendItem.js.map